import React, { Component } from 'react';
import { Translate } from '$common';



export default class DateTime extends Component {
  static type = 'date_time';
  static elementName = Translate.get('date_time');
  static icon = 'calendar';

  render() {
    return null;
  }
}



// WEBPACK FOOTER //
// ./src/components/task-form/question-types/date-time.js